import React, { useState, useEffect } from 'react';
import '../../styles/group/GroupHeader.css';

const GroupHeader = ({ group }) => {
  const [logoSrc, setLogoSrc] = useState(null);
  const [logoError, setLogoError] = useState(false);
  
  // Simple and direct logo handling - same as AdminProfilePage
  useEffect(() => {
    if (group?.logo_url) {
      console.log(`GroupHeader: Setting logo for ${group.name} (${group.id}):`, group.logo_url);
      setLogoError(false);
      setLogoSrc(group.logo_url);
    } else {
      console.log(`GroupHeader: No logo URL for group ${group?.name || 'unknown'}, using default`);
      setLogoError(false);
      setLogoSrc(null);
    }
  }, [group]);
  
  return (
    <div className="group-header">
      <div className="group-header-content">
        <div 
          className="group-logo-container"
          style={{ 
            backgroundImage: logoSrc ? `url(${logoSrc})` : 'url(https://xvhellooihpelwifxuik.supabase.co/storage/v1/object/public/assets//Yesodsybol%20(1).jpeg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          {/* Empty div - image is now displayed as background */}
        </div>
        <h1 className="group-name">{group.name}</h1>
      </div>
    </div>
  );
};

export default GroupHeader;